document.addEventListener("DOMContentLoaded", function () {
  AOS.init({
    duration: 1000,
    once: true,
  });
});

class ProductCard extends HTMLElement {
  constructor() {
    super();

    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");

    this.quickBuyButton = this.querySelector("product-form .quick-add__submit");

    if (this.quickBuyButton) {
      this.quickBuyButton.addEventListener("click", (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }
  }

  addToCart() {
    let card = this;
    let cart = card.cart;
    let input = this.querySelector(".product-variant-id");
    let selectedValue = input.value;
    let label = card.quickBuyButton.querySelector(".label");
    let buttonLabel = label.dataset.label;
    let buttonInProgressLabel = label.dataset.inProgressLabel;

    card.quickBuyButton.setAttribute("disabled", "disabled");
    label.innerHTML = buttonInProgressLabel;

    // Add selected variant to cart
    let formData = {
      items: [
        {
          id: selectedValue,
          quantity: 1,
        },
      ],
      sections: cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    };

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.sections) {
          // Refresh the cart preview
          cart.renderContents(response);
          if (cart && cart.classList.contains("is-empty")) {
            cart.classList.remove("is-empty");
          }
        }

        card.quickBuyButton.removeAttribute("disabled");
        label.innerHTML = buttonLabel;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

window.customElements.define("product-card", ProductCard);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      autoplay: {
        delay: 5000,
      },
      speed: 500,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });
  }
}

window.customElements.define("announcement-bar", AnnouncementBar);

class ArticleRelatedProducts extends HTMLElement {
  constructor() {
    super();

    const collections = this.querySelectorAll(
      ".featured-collections__collection"
    );

    const breakpoint = window.matchMedia("(max-width: 700px)");
    let swiperObjs = [];

    const breakpointChecker = () => {
      if (breakpoint.matches === true) {
        if (swiperObjs.length > 0) {
          swiperObjs.forEach((swiper) => {
            swiper.destroy();
          });
          swiperObjs = [];
        }
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = () => {
      [...collections].forEach((collection) => {
        let el = collection.querySelector(".swiper");
        let prevEl = collection.querySelector(".swiper-prev");
        let nextEl = collection.querySelector(".swiper-next");
        let swiper = new Swiper(el, {
          speed: 1000,
          slidesPerView: 1.15,
          spaceBetween: 0,
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          breakpoints: {
            700: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 33,
            },
            900: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 33,
            },
            1200: {
              slidesPerView: 4,
              slidesPerGroup: 4,
              spaceBetween: 33,
            },
          },
        });
        swiperObjs.push(swiper);
      });
    };

    breakpoint.addEventListener("change", breakpointChecker);
    breakpointChecker();
  }
}

window.customElements.define(
  "article-related-products",
  ArticleRelatedProducts
);

class CartRecommendations extends HTMLElement {
  constructor() {
    super();

    let element = this;
    let productId = element.getAttribute("data-product");

    fetch(
      window.Shopify.routes.root +
        "recommendations/products?product_id=" +
        productId +
        "&limit=10&section_id=cart-recommendations&intent=related"
    )
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector("cart-recommendations");

        if (recommendations && recommendations.innerHTML.trim().length) {
          element.innerHTML = recommendations.innerHTML;
        }
      });
  }
}

window.customElements.define("cart-recommendations", CartRecommendations);

class CollectionGrid extends HTMLElement {
  constructor() {
    super();

    this.setupFacetsButtons();
  }

  setupFacetsButtons = () => {
    const facetOpenButton = this.querySelector(".mobile-facets__open-wrapper");
    const facetCloseButton = this.querySelector(".drawer__close");
    const wrapper = this.querySelector(".facets-wrapper");

    facetOpenButton.addEventListener("click", () => {
      if (wrapper.classList.contains("open")) {
        document.body.classList.remove("facets-open");
        wrapper.classList.remove("open");
        return;
      }
      document.body.classList.add("facets-open");
      wrapper.classList.add("open");
    });

    facetCloseButton.addEventListener("click", () => {
      document.body.classList.remove("facets-open");
      wrapper.classList.remove("open");
    });

    const facetButtons = this.querySelectorAll(".mobile-facets__summary");
    facetButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.nextElementSibling.classList.contains("open")) {
          button.nextElementSibling.classList.remove("open");
          button.classList.remove("open");
          return;
        }
        button.nextElementSibling.classList.add("open");
        button.classList.add("open");
      });
    });
  };
}

window.customElements.define("collection-grid", CollectionGrid);

class FaqsComponent extends HTMLElement {
  constructor() {
    super();

    let component = this;
    let categories = document.querySelectorAll(".faqs-category");
    let buttons = document.querySelector(".faqs__buttons");
    let questions = component.querySelectorAll(".faqs__question");

    if (categories.length > 0) {
      categories.forEach((category) => {
        component.appendChild(category);

        questions = category.querySelectorAll(".faqs__question");

        [...questions].forEach((question) => {
          let item = question.parentElement;
          let answer = item.querySelector(".faqs__answer");
          let answerContainer = item.querySelector(".faqs__answer-container");

          question.addEventListener("click", () => {
            if (item.classList.contains("active")) {
              answer.style.height = 0;
              item.classList.remove("active");
            } else {
              answer.style.height = answerContainer.offsetHeight + "px";
              item.classList.add("active");
            }
          });
        });

        let heading = category.querySelector(".faqs__heading");
        let headingText = heading.innerText;
        let id = category.getAttribute("id");

        let button = document.createElement("button");
        button.classList.add("faqs__button", "button");
        button.innerText = headingText;
        button.dataset.target = "#" + id;

        buttons.appendChild(button);

        button.addEventListener("click", () => {
          let target = button.dataset.target;
          let targetCategory = document.querySelector(target);

          // scroll to targetCategory
          let offset = targetCategory.offsetTop - 160;
          window.scrollTo({
            top: offset,
            behavior: "smooth",
          });
        });
      });
    } else if (questions.length > 0) {
      [...questions].forEach((question) => {
        let item = question.parentElement;
        let answer = item.querySelector(".faqs__answer");
        let answerContainer = item.querySelector(".faqs__answer-container");

        question.addEventListener("click", () => {
          if (item.classList.contains("active")) {
            answer.style.height = 0;
            item.classList.remove("active");
          } else {
            answer.style.height = answerContainer.offsetHeight + "px";
            item.classList.add("active");
          }
        });
      });
    }
  }
}

window.customElements.define("faqs-component", FaqsComponent);

class FeaturedCollections extends HTMLElement {
  constructor() {
    super();

    const buttons = this.querySelectorAll(".featured-collections__link");
    const collections = this.querySelectorAll(
      ".featured-collections__collection"
    );
    const contentBlocksDesktop = this.querySelectorAll(
      ".featured-collections__content--desktop .featured-collections__content-block"
    );
    const contentBlocksMobile = this.querySelectorAll(
      ".featured-collections__content--mobile .featured-collections__content-block"
    );
    const breakpoint = window.matchMedia("(max-width: 700px)");
    let swiperObjs = [];

    const fadeIn = (el) => {
      el.classList.add("active");
      gsap.to(el, {
        duration: 1,
        opacity: 1,
        ease: "power2.out",
      });
    };

    const fadeOut = (el) => {
      el.classList.remove("active");
      gsap.to(el, {
        duration: 1,
        opacity: 0,
        ease: "power2.out",
      });
    };

    if (buttons.length > 0) {
      buttons[0].classList.add("active");
      fadeIn(collections[0]);
      fadeIn(contentBlocksDesktop[0]);
      fadeIn(contentBlocksMobile[0]);

      [...buttons].forEach((button, index) => {
        button.addEventListener("click", (e) => {
          buttons.forEach((el) => el.classList.remove("active"));
          collections.forEach((el) => fadeOut(el));
          contentBlocksDesktop.forEach((el) => fadeOut(el));
          contentBlocksMobile.forEach((el) => fadeOut(el));

          button.classList.add("active");
          fadeIn(collections[button.dataset.id - 1]);
          fadeIn(contentBlocksDesktop[button.dataset.id - 1]);
          fadeIn(contentBlocksMobile[button.dataset.id - 1]);
        });
      });
    }

    const breakpointChecker = () => {
      if (breakpoint.matches === true) {
        if (swiperObjs.length > 0) {
          swiperObjs.forEach((swiper) => {
            swiper.destroy();
          });
          swiperObjs = [];
        }
      } else if (breakpoint.matches === false) {
        return enableSwiper();
      }
    };

    const enableSwiper = () => {
      [...collections].forEach((collection) => {
        let el = collection.querySelector(".swiper");
        let prevEl = collection.querySelector(".swiper-prev");
        let nextEl = collection.querySelector(".swiper-next");
        let swiper = new Swiper(el, {
          speed: 1000,
          slidesPerView: 1.15,
          spaceBetween: 0,
          navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
          },
          breakpoints: {
            700: {
              slidesPerView: 1,
              slidesPerGroup: 1,
              spaceBetween: 33,
            },
            900: {
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 33,
            },
            1200: {
              slidesPerView: 3,
              slidesPerGroup: 3,
              spaceBetween: 33,
            },
          },
        });
        swiperObjs.push(swiper);
      });
    };

    breakpoint.addEventListener("change", breakpointChecker);
    breakpointChecker();
  }
}

window.customElements.define("featured-collections", FeaturedCollections);

class FeaturedLinks extends HTMLElement {
  constructor() {
    super();

    const links = this.querySelectorAll(".featured-links__link");
    const images = this.querySelectorAll(".featured-links__image img");

    [...links].forEach((link, index) => {
      link.addEventListener("mouseenter", (e) => {
        let id = link.dataset.id;
        images.forEach((el) => {
          if (el.dataset.id !== id) {
            el.style.opacity = 0;
          } else {
            el.style.opacity = 1;
          }
        });
      });
    });
  }
}

window.customElements.define("featured-links", FeaturedLinks);

class Header extends HTMLElement {
  constructor() {
    super();

    const header = this;
    const menuButton = this.querySelector(".menu-button");
    const closeButton = this.querySelector(".close-button");
    const body = document.querySelector("body");
    const dropdowns = this.querySelectorAll(".main-menu .has-child");
    const accordions = this.querySelectorAll(".mobile-menu .has-child");
    const mobileTopButtons = this.querySelectorAll(".mobile-menu-buttons a");
    const mobileMenus = this.querySelectorAll(".mobile-menu-list");

    function openAccordion(item, instant = false) {
      let menu = item.querySelector("div");
      let icon = item.querySelector(".accordion-icon");
      let duration = 0.5;

      if (instant) {
        duration = 0;
      }

      gsap.to(menu, {
        height: "auto",
        duration: duration,
      });

      item.classList.add("active");

      icon.innerText = "-";
    }

    function closeAccordion(item, instant = false) {
      let menu = item.querySelector("div");
      let icon = item.querySelector(".accordion-icon");
      let duration = 0.5;

      if (instant) {
        duration = 0;
      }

      gsap.to(menu, {
        height: 0,
        duration: duration,
      });

      item.classList.remove("active");

      icon.innerText = "+";
    }

    mobileTopButtons[0].classList.add("active");
    mobileMenus[0].classList.add("active");
    let firstMenu = mobileMenus[0].querySelector("li:first-child");
    openAccordion(firstMenu, true);

    [...mobileTopButtons].forEach((button, index) => {
      if (button.hasAttribute("data-additional-button")) {
        return;
      }

      button.addEventListener("click", (e) => {
        e.preventDefault();

        mobileTopButtons.forEach((button) => {
          button.classList.remove("active");
        });

        mobileMenus.forEach((menu) => {
          menu.classList.remove("active");
        });

        accordions.forEach((accordion) => {
          accordion.classList.remove("active");
          closeAccordion(accordion, true);
        });

        button.classList.add("active");

        let menu = mobileMenus[index];
        menu.classList.add("active");

        let accordion = menu.querySelector("li:first-child");
        openAccordion(accordion, true);
      });
    });

    [...dropdowns].forEach((dropdown) => {
      dropdown.addEventListener("mouseenter", () => {
        let submenu = dropdown.querySelector(".submenu");
        let height = submenu.offsetHeight;

        submenu.style.height = height + "px";
      });
    });

    [...accordions].forEach((accordion) => {
      accordion.addEventListener("click", (e) => {
        if (e.target.tagName === "A") {
          return;
        }
        if (accordion.classList.contains("active")) {
          closeAccordion(accordion);
        } else {
          openAccordion(accordion);
        }
      });
    });

    menuButton.addEventListener("click", () => {
      const scrollY = window.scrollY;
      header.classList.add("menu-open");
      body.classList.add("menu-open");
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
    });

    closeButton.addEventListener("click", () => {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);

      header.classList.remove("menu-open");
      body.classList.remove("menu-open");
    });

    window.addEventListener(
      "scroll",
      () => {
        const currentScroll = window.pageYOffset;
        if (currentScroll > 0) {
          header.classList.add("scroll");
        } else {
          header.classList.remove("scroll");
        }
      },
      { passive: true }
    );
  }
}

window.customElements.define("header-component", Header);

class HeroComponent extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      speed: 500,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
    });
  }
}

window.customElements.define("hero-component", HeroComponent);

class Instagram extends HTMLElement {
  constructor() {
    super();

    const swiperEl = this.querySelector(".swiper");

    const swiper = new Swiper(swiperEl, {
      centeredSlides: false,
      speed: 6000,
      spaceBetween: 9,
      autoplay: {
        delay: 0,
      },
      loop: true,
      slidesPerView: 3,
      allowTouchMove: false,
      breakpoints: {
        800: {
          spaceBetween: 16,
          slidesPerView: 5,
        },
        1000: {
          spaceBetween: 16,
          slidesPerView: 6,
        },
        1200: {
          spaceBetween: 16,
          slidesPerView: 7,
        },
        1400: {
          spaceBetween: 16,
          slidesPerView: 8,
        },
      },
    });
  }
}

window.customElements.define("instagram-block", Instagram);

class LoadMore extends HTMLElement {
  constructor() {
    super();
    console.log("LoadMore");

    const cards_on_page = this.querySelector("[data-load-more-grid]");
    let next_url = cards_on_page.dataset.nextUrl;
    let more_pages = true;

    const intersectionObserver = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio <= 0) return;
      // load more content;
      loadMoreProducts();
    });
    // start observing
    intersectionObserver.observe(document.querySelector(".load-more-item"));

    async function getNextPage() {
      try {
        let res = await fetch(next_url);
        return await res.text();
      } catch (error) {
        console.log("error", error);
      }
    }

    async function loadMoreProducts() {
      if (!more_pages) {
        return;
      }
      let nextPage = await getNextPage();

      const parser = new DOMParser();
      const nextPageDoc = parser.parseFromString(nextPage, "text/html");

      const cardGrid = nextPageDoc.querySelector("[data-load-more-grid]");
      const new_products = cardGrid.getElementsByClassName("load-item");

      const new_url = cardGrid.dataset.nextUrl;
      if (!new_url) {
        more_pages = false;
      }
      next_url = new_url;

      [...new_products].forEach((product) => {
        cards_on_page.appendChild(product);
      });
    }
  }
}

window.customElements.define("load-more", LoadMore);

class LoginDrawer extends HTMLElement {
  constructor() {
    super();

    const guestLink = document.querySelector(".account-button.guest");

    if (guestLink) {
      this.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );
      this.querySelector("#LoginDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.setHeaderAccountIconAccessibility();
      this.recover();
      this.login();
      this.register();
    }
  }

  login() {
    const loginLinks = this.querySelectorAll(".login-link");
    const loginBody = this.querySelector(".drawer__login");
    const recoverBody = this.querySelector(".drawer__recover");
    const registerBody = this.querySelector(".drawer__register");

    [...loginLinks].forEach((loginLink) => {
      loginLink.addEventListener("click", (event) => {
        event.preventDefault();
        registerBody.classList.remove("active");
        recoverBody.classList.remove("active");
        loginBody.classList.add("active");
      });
    });
  }

  recover() {
    const recoverLink = this.querySelector(".recover-link");
    const loginBody = this.querySelector(".drawer__login");
    const recoverBody = this.querySelector(".drawer__recover");
    recoverLink.addEventListener("click", (event) => {
      event.preventDefault();
      loginBody.classList.remove("active");
      recoverBody.classList.add("active");
    });
  }

  register() {
    const registerLink = this.querySelector(".register-link");
    const loginBody = this.querySelector(".drawer__login");
    const registerBody = this.querySelector(".drawer__register");
    registerLink.addEventListener("click", (event) => {
      event.preventDefault();
      loginBody.classList.remove("active");
      registerBody.classList.add("active");
    });
  }

  setHeaderAccountIconAccessibility() {
    const loginLinks = document.querySelectorAll(".account-button.guest");

    [...loginLinks].forEach((loginLink) => {
      loginLink.setAttribute("role", "button");
      loginLink.setAttribute("aria-haspopup", "dialog");
      loginLink.addEventListener("click", (event) => {
        console.log("event", event);
        event.preventDefault();
        this.open();
      });
      loginLink.addEventListener("keydown", (event) => {
        if (event.code.toUpperCase() === "SPACE") {
          event.preventDefault();
          this.open();
        }
      });
    });
  }

  open() {
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("overflow-hidden");
  }
}

customElements.define("login-drawer", LoginDrawer);

class MediaGalleryBlock extends HTMLElement {
  constructor() {
    super();

    let el = this.querySelector(".swiper");
    let prevEl = this.querySelector(".swiper-prev");
    let nextEl = this.querySelector(".swiper-next");
    this.swiperEl = new Swiper(el, {
      speed: 1000,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        nextEl: nextEl,
        prevEl: prevEl,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }
}

window.customElements.define("media-gallery-block", MediaGalleryBlock);

class ProductFollowBar extends HTMLElement {
  constructor() {
    super();

    let element = this;
    let mainProduct = document.querySelector(".main-product");
    let mainProductHeight = mainProduct.offsetHeight;
    let productInfo = document.querySelector("product-info");
    let productInfoTop = productInfo.getBoundingClientRect().top;
    let button = element.querySelector(".button");
    let variants = document.querySelector("variant-selects");

    window.addEventListener("scroll", () => {
      if (window.scrollY > mainProductHeight) {
        element.style.visibility = "visible";
        element.style.opacity = 1;
      } else {
        element.style.visibility = "hidden";
        element.style.opacity = 0;
      }
    });

    button.addEventListener("click", () => {
      if (variants) {
        productInfo.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      } else {
        if (!button.classList.contains("disabled")) {
          let cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");

          let buttonLabel = button.dataset.label;
          let buttonInProgressLabel = button.dataset.inProgressLabel;

          let formData = {
            items: [
              {
                id: button.dataset.variantId,
                quantity: 1,
              },
            ],
            sections: cart.getSectionsToRender().map((section) => section.id),
            sections_url: window.location.pathname,
          };

          button.innerHTML = buttonInProgressLabel;
          button.classList.add("disabled");

          fetch(window.Shopify.routes.root + "cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          })
            .then((response) => {
              return response.json();
            })
            .then((response) => {
              if (response.sections) {
                // Refresh the cart preview
                cart.renderContents(response);
                if (cart && cart.classList.contains("is-empty")) {
                  cart.classList.remove("is-empty");
                }
              }

              button.innerHTML = buttonLabel;
              button.classList.remove("disabled");
            })
            .catch((error) => {
              console.error("Error:", error);
            });
        }
      }
    });
  }
}

window.customElements.define("product-follow-bar", ProductFollowBar);

class ProductTabs extends HTMLElement {
  constructor() {
    super();
    let section = this;

    let buttons = this.querySelectorAll(".product-tabs__buttons .button");
    let tabs = this.querySelectorAll(".product-tabs__tab");

    [...buttons].forEach((button) => {
      button.addEventListener("click", (event) => {
        let targetId = button.dataset.tab;

        [...buttons].forEach((button) => {
          button.classList.remove("active");
        });
        [...tabs].forEach((tab) => {
          tab.classList.remove("active");
        });

        let tab = section.querySelector(
          `.product-tabs__tab[data-id="${targetId}"]`
        );

        tab.classList.add("active");
        button.classList.add("active");
      });
    });
  }
}

window.customElements.define("product-tabs", ProductTabs);

document.addEventListener("DOMContentLoaded", function () {
  let search = document.querySelector(".header__search");
  let searchInput = search.querySelector("input");
  let overlay = search.querySelector(".modal-overlay");
  let searchModalContent = search.querySelector(".search-modal__content");
  let closeButton = search.querySelector(".search-modal__close-button");
  let openButton = search.querySelector(".search-button");
  let main = document.querySelector("#MainContent");
  let searchTextButton = document.querySelector(".template-search__header .h2");
  let scrollY = window.scrollY;

  if (searchTextButton) {
    searchTextButton.addEventListener("click", function () {
      openButton.click();
    });
  }

  overlay.addEventListener("click", function () {
    let results = document.querySelector("#predictive-search-results");
    if (results) {
      results.remove();
    }
    searchInput.value = "";
    document.body.style.position = "";
    document.body.style.top = "";
    search.classList.remove("open");
    main.style.zIndex = "unset";
    window.scrollTo(0, parseInt(scrollY || "0"));
  });

  closeButton.addEventListener("click", function () {
    let results = search.querySelector("#predictive-search-results");
    if (results) {
      results.remove();
    }
    searchInput.value = "";
    document.body.style.position = "";
    document.body.style.top = "";
    search.classList.remove("open");
    main.style.zIndex = "unset";
    window.scrollTo(0, parseInt(scrollY || "0"));
  });

  openButton.addEventListener("click", function () {
    scrollY = window.scrollY;
    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    search.classList.add("open");
    main.style.zIndex = "-1";
    searchModalContent.addEventListener("transitionend", function focusInput(event) {
      if (event.target === searchModalContent) {
          searchInput.focus();
          searchModalContent.removeEventListener("transitionend", focusInput);
      }
    });
  });

});

class ShopTheLook extends HTMLElement {
  constructor() {
    super();

    let blobs = this.querySelectorAll(".shop-the-look__blob");
    let section = this.closest("section");
    let popup = section.querySelector(".shop-the-look__popup");
    let popupClose = section.querySelector(".shop-the-look__popup-close");

    if (window.innerWidth > 900) {
      blobs[0].classList.add("active");

      const swiperEl = this.querySelector(".swiper--desktop");

      const swiper = new Swiper(swiperEl, {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        speed: 500,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        on: {
          slideChange: function () {
            blobs.forEach((blob) => blob.classList.remove("active"));
            blobs[this.realIndex].classList.add("active");
          },
        },
      });

      [...blobs].forEach((blob, index) => {
        blob.addEventListener("click", () => {
          blobs.forEach((blob) => blob.classList.remove("active"));

          blob.classList.add("active");
          swiper.slideTo(index);
        });
      });
    } else {
      const swiperEl = section.querySelector(".swiper--mobile");

      const swiper = new Swiper(swiperEl, {
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        speed: 500,
        effect: "fade",
        fadeEffect: {
          crossFade: true,
        },
        on: {
          slideChange: function () {
            blobs.forEach((blob) => blob.classList.remove("active"));
            blobs[this.realIndex].classList.add("active");
          },
        },
      });

      [...blobs].forEach((blob, index) => {
        blob.addEventListener("click", () => {
          blobs.forEach((blob) => blob.classList.remove("active"));
          popup.classList.add("active");

          blob.classList.add("active");
          swiper.slideTo(index);
        });
      });

      popupClose.addEventListener("click", () => {
        popup.classList.remove("active");
        [...blobs].forEach((blob, index) => {
          blob.classList.remove("active");
        });
      });
    }
  }
}

window.customElements.define("shop-the-look", ShopTheLook);
